import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraLink, SpecraSurface, SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
/** WRT-30: a material that pins a region of an ONLYOFFICE document version. */ export function isDocumentMaterial(m) {
    return !m.sectionVersionId && !!m.documentVersionId;
}
/** "v7 · Pink team" for a document pin (number/label when shirohige knew them); "v3" for TipTap. */ export function materialVersionText(m) {
    if (!isDocumentMaterial(m)) return `v${m.sectionVersion}`;
    const n = m.documentVersionNumber ? `v${m.documentVersionNumber}` : 'pinned version';
    return m.documentVersionLabel ? `${n} · ${m.documentVersionLabel}` : n;
}
/**
 * A document material (WRT-30): the section title, "v{n} · {label}", the
 * region text exactly as pinned (read-only) and a link to open that version
 * read-only in the workspace (`?version=`).
 */ export function DocumentMaterial({ material, sectionHref, title }) {
    const versionHref = sectionHref ? `${sectionHref}?version=${encodeURIComponent(material.documentVersionId)}` : '';
    return /*#__PURE__*/ _jsxs("div", {
        className: "rounded-lg border border-border bg-card p-3 text-sm",
        "data-material-id": material.id,
        "data-testid": Testids.proposalReviews.materialRow,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-medium",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(SpecraBadge, {
                        variant: "violet",
                        children: materialVersionText(material)
                    }),
                    versionHref ? /*#__PURE__*/ _jsx(SpecraLink, {
                        "data-testid": Testids.proposalReviews.materialOpenVersion,
                        href: versionHref,
                        renderLink: renderRouterLink,
                        children: "Open this version"
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraSurface, {
                className: "mt-2",
                padding: "sm",
                children: /*#__PURE__*/ _jsx(SpecraText, {
                    as: "p",
                    className: "whitespace-pre-wrap",
                    "data-testid": Testids.proposalReviews.materialRegion,
                    size: "body-sm",
                    children: material.regionText || 'This section had no text when it was pinned.'
                })
            })
        ]
    });
}
